import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

const KEY = "kintsugi_calendly_auto_sync_at";
export const CALENDLY_SYNCED_EVENT = "kintsugi:calendly-synced";

/** Synchro Calendly silencieuse à l'ouverture de l'app (au plus une fois par heure, côté client et côté serveur). */
export const autoSyncCalendly = async () => {
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 60 * 60 * 1000) return;
  sessionStorage.setItem(KEY, String(Date.now()));
  try {
    const start = await axios.post(`${API}/calendly/sync?auto=1`, {}, { withCredentials: true });
    if (!start.data.job_id) return;
    for (let i = 0; i < 240; i++) {
      await new Promise((r) => setTimeout(r, 3000));
      const j = (await axios.get(`${API}/calendly/sync/${start.data.job_id}`, { withCredentials: true })).data;
      if (j.status === "completed") {
        const s = j.result || {};
        if (s.reports_created || s.appointments) {
          toast.success(`Calendly synchronisé : ${s.reports_created} séance(s) créée(s) · ${s.appointments} RDV à venir`, { duration: 6000 });
        }
        window.dispatchEvent(new CustomEvent(CALENDLY_SYNCED_EVENT, { detail: s }));
        return;
      }
      if (j.status === "error") return;
    }
  } catch { /* silencieux : la synchro manuelle reste disponible */ }
};
